module.exports = __webpack_public_path__ + "img/running_glasses.c29abfa5.jpeg";